import { CheckCircle } from 'lucide-react';

// Section aplat primary-900 (#0E2348) — retour au sombre apres la bande claire Workflow.
// Bande de liaison en tete : degrade clair->sombre pour eviter le choc visuel.
const AcademicModuleSection = () => {
  return (
    <section className="bg-primary-900 text-white">
      <div className="py-20">
        <div className="container mx-auto px-6 flex flex-col md:flex-row items-center gap-12">

          {/* Copy */}
          <div className="md:w-1/2">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-white mb-6">
              Plus qu'un agenda : un vrai carnet de notes.
            </h2>
            <p className="font-sans text-sky-muted text-lg mb-8 leading-relaxed">
              Le répétiteur saisit interros et devoirs avec leur coefficient. MyEduCycle en tire les moyennes par matière et par trimestre — les mêmes règles que le carnet de l'école, sans les erreurs de calcul.
            </p>
            <ul className="space-y-4 font-sans">
              <li className="flex items-center gap-3">
                <CheckCircle className="text-success shrink-0" size={24} />
                <span className="text-sky-muted">Moyennes calculées automatiquement, par matière et par période</span>
              </li>
              <li className="flex items-center gap-3">
                <CheckCircle className="text-success shrink-0" size={24} />
                <span className="text-sky-muted">Historique des notions vues à chaque séance</span>
              </li>
              <li className="flex items-center gap-3">
                <CheckCircle className="text-success shrink-0" size={24} />
                <span className="text-sky-muted">Évolution du niveau suivie sur 3 ans</span>
              </li>
            </ul>
          </div>

          {/* Mock calcul notes — carte glass coherente avec FeatureCard */}
          <div className="md:w-1/2 bg-white/5 border border-white/10 p-8 rounded-3xl backdrop-blur-sm">
            <div className="flex flex-col gap-4">
              <div className="flex justify-between items-center bg-white/8 p-4 rounded-xl">
                <span className="font-sans text-sky-muted">Interros (Coeff 1)</span>
                <span className="font-display font-semibold text-success">14, 16, 15</span>
              </div>
              <div className="flex justify-between items-center bg-white/8 p-4 rounded-xl">
                <span className="font-sans text-sky-muted">Devoirs (Coeff 2)</span>
                <span className="font-display font-semibold text-success">13, 17</span>
              </div>
              <div className="h-px bg-white/15 my-2"></div>
              <div className="flex justify-between items-center">
                <span className="font-display text-xl font-semibold text-white">Moyenne Trimestre</span>
                {/* Score en accent — contraste garanti sur fond nuit */}
                <span className="font-display text-3xl font-bold text-accent">15.2/20</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AcademicModuleSection;
